module.exports = __webpack_public_path__ + "static/media/org_address.9df3c6de.svg";